import { getCurrentUser } from 'aws-amplify/auth/server';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const hasActiveUserSessionWithAppRouter = async ({ request, runWithAmplifyServerContext, }) => {
    const dummyResponse = new Response();
    try {
        await runWithAmplifyServerContext({
            nextServerContext: { request, response: dummyResponse },
            operation(contextSpec) {
                return getCurrentUser(contextSpec);
            },
        });
        return true;
    }
    catch (_) {
        // `getCurrentUser()` throws if there is no valid token
        return false;
    }
};
const hasActiveUserSessionWithPagesRouter = async ({ request, response, runWithAmplifyServerContext, }) => {
    try {
        await runWithAmplifyServerContext({
            nextServerContext: { request, response },
            operation(contextSpec) {
                return getCurrentUser(contextSpec);
            },
        });
        return true;
    }
    catch (_) {
        // `getCurrentUser()` throws if there is no valid token
        return false;
    }
};

export { hasActiveUserSessionWithAppRouter, hasActiveUserSessionWithPagesRouter };
//# sourceMappingURL=hasActiveUserSession.mjs.map
